export {
  ApolloCache,
  ApolloClient,
  ApolloError,
  ApolloLink,
  ApolloProvider,
  HttpLink,
  InMemoryCache,
  NetworkStatus,
  gql,
  makeVar,
  useApolloClient,
  useReactiveVar,
  type ApolloQueryResult,
  type Context,
  type FetchResult,
  type FieldFunctionOptions,
  type InMemoryCacheConfig,
  type LazyQueryHookOptions,
  type MutationFunctionOptions,
  type MutationHookOptions,
  type MutationResult,
  type MutationTuple,
  type NormalizedCacheObject,
  type OperationVariables,
  type PureQueryOptions,
  type QueryFunctionOptions,
  type QueryHookOptions,
  type QueryLazyOptions,
  type QueryResult,
  type QueryTuple,
  type Reference,
  type RequestHandler,
  type ServerError,
  type ServerParseError,
  type StoreObject
} from '@apollo/client';
export { onError } from '@apollo/client/link/error';
export { RetryLink } from '@apollo/client/link/retry';
export { cloneDeep } from '@apollo/client/utilities';
export { createApolloClient } from './createApolloClient';
export { parseGraphqlError } from '../utils/handleGraphqlErrors';
import React from 'react';
import {
  isCloudflareChallengeError as isCloudflareChallengeError0,
  isEdgePermissionDeniedError as isEdgePermissionDeniedError0,
  isServerError as isServerError0,
  isServerParseError as isServerParseError0
} from './guards';
import {
  useQuery as useQuery0,
  useMutation as useMutation0,
  useLazyQuery as useLazyQuery0
} from '@apollo/client';

/**
 * @deprecated Exposed so they can be available temporarily during RBAC and Per App error processing migrations
 * DO NOT USE
 */
export const isServerParseError = isServerParseError0;
/**
 * @deprecated Exposed so they can be available temporarily during RBAC and Per App error processing migrations
 * DO NOT USE
 */
export const isServerError = isServerError0;
/**
 * @deprecated Exposed so they can be available temporarily during RBAC and Per App error processing migrations
 * DO NOT USE
 */
export const isCloudflareChallengeError = isCloudflareChallengeError0;
/**
 * @deprecated Exposed so they can be available temporarily during RBAC and Per App error processing migrations
 * DO NOT USE
 */
export const isEdgePermissionDeniedError = isEdgePermissionDeniedError0;

/**
 * Used by hooks in this module to get the stack trace of the caller.
 */
function useInternalGetCallerStack(): string {
  /**
   * Use useRef instead of useMemo to avoid adding anything to the error stack.
   */
  const stackRef = React.useRef<string | null>(null);

  if (stackRef.current === null) {
    const stack = new Error().stack;
    /**
     * The first 3 lines of the stack are:
     * 1. Error
     * 2. at useInternalGetCallerStack
     * 3. at useQuery (or whatever hook is calling this)
     * We want to skip these lines.
     */
    const lines = stack?.split('\n').slice(3) ?? [];

    stackRef.current = ['Error', ...lines].join('\n');
  }

  return stackRef.current;
}

export const useQuery: typeof useQuery0 = (document, options = {}) => {
  options.context = {
    ...options.context,
    LOBSTER_ROLL_SENTRY_INDIRECT_STACK: useInternalGetCallerStack()
  };
  return useQuery0(document, options);
};

export const useMutation: typeof useMutation0 = (document, options = {}) => {
  options.context = {
    ...options.context,
    LOBSTER_ROLL_SENTRY_INDIRECT_STACK: useInternalGetCallerStack()
  };
  return useMutation0(document, options);
};

export const useLazyQuery: typeof useLazyQuery0 = (document, options = {}) => {
  options.context = {
    ...options.context,
    LOBSTER_ROLL_SENTRY_INDIRECT_STACK: useInternalGetCallerStack()
  };
  return useLazyQuery0(document, options);
};
